// Heartbeat: PATCH /student-papers/:spId/time every 30s with effort metrics.
import { useEffect } from 'react';
import { apiPatch } from '@/lib/api';
import { useExamStore } from '@/store/examStore';

export function useEffortSync(spId: string | null): void {
  useEffect(() => {
    if (!spId) return;
    const interval = window.setInterval(() => {
      const { effortTracking, elapsedSeconds } = useExamStore.getState();
      // Deliberate exception to "no writes from effects": a 30s heartbeat PATCH
      // that overwrites the same per-session counters (last-write-wins;
      // double-firing is harmless).
      // eslint-disable-next-line no-restricted-syntax -- see comment above
      void apiPatch(`/student-papers/${spId}/time`, {
        totalTimeOnTask: elapsedSeconds,
        hintTimeSeconds: effortTracking.hintSeconds,
        videoTimeSeconds: effortTracking.videoSeconds,
        theoryTimeSeconds: effortTracking.theorySeconds,
      }).catch(() => {
        /* best-effort heartbeat; ignore transient failures */
      });
    }, 30_000);
    return () => window.clearInterval(interval);
  }, [spId]);
}
